export default "__VITE_PUBLIC_ASSET__83f6d1aa__"